import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertCircle, FiTrendingDown, FiHelpCircle } = FiIcons;

const PainPoints = () => {
  const painPoints = [
    {
      icon: FiTrendingDown,
      title: "เงินไม่พอใช้ ไม่ว่าจะทำงานหนักแค่ไหน?",
      description: "รายได้มีแต่ไม่เคยเหลือ ทำงานหนักแต่เงินไม่เข้ากระเป๋า"
    },
    {
      icon: FiAlertCircle,
      title: "รู้สึกว่าชะตาการเงินไม่ดี?",
      description: "มีโอกาสทำเงินแต่มักพลาดไป หรือมีปัญหาขัดขวางเสมอ"
    },
    {
      icon: FiHelpCircle,
      title: "ไม่รู้ว่าจะเสริมดวงการเงินอย่างไร?",
      description: "ลองหลายวิธีแล้วแต่ไม่เห็นผล หรือไม่รู้ว่าจะเริ่มจากตรงไหน"
    }
  ];

  return (
    <section className="py-16 px-4">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            คุณกำลังเผชิญกับปัญหาเหล่านี้อยู่ไหม?
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            หากคุณรู้สึกว่าชีวิตการเงินของคุณไม่ราบรื่นเหมือนที่ควรจะเป็น...
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {painPoints.map((point, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-8 border border-red-500/20 hover:border-red-500/40 transition-all duration-300"
            >
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <SafeIcon icon={point.icon} className="text-white text-2xl" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4">
                  {point.title}
                </h3>
                <p className="text-slate-300 leading-relaxed">
                  {point.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-center mt-12"
        >
          <p className="text-2xl text-amber-400 font-bold">
            หากคุณตอบ "ใช่" แม้แต่ข้อเดียว...
          </p>
          <p className="text-xl text-white mt-4">
            หลักสูตรนี้คือคำตอบที่คุณตามหา
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default PainPoints;